// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3LCYJ","last":"styles_last__tf5x5"};